
// departamentoService.js
import api from './api';

export const departamentoService = {
    obtenerTodos: () => api.get('/get/obtener_departamentos.php')
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        }))
};
